module.exports = __webpack_public_path__ + "img/ad.5a1ec016.png";